import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import { AxiosPromise } from 'axios';
const rootPath = 'interfaceElements';
import { Vue } from 'vue-property-decorator';

class InterfaceElementService extends Vue {

    public async GetTranslationFile(lang: string): Promise<any> {
        return apiClient.get(`${rootPath}/GetTranslationFile${buildQuery({ lang })}`);
    }

    public getTranslationsUrl(): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}/GetAllTranslations`;
    }

    public addTranslations(data: any): AxiosPromise {
        return apiClient.put(`${rootPath}/addTranslations/${data.id}`, data);
    }

}

export default new InterfaceElementService();